import { defineStore } from "pinia";

import modelClass from "@models/news-article";
import * as getters from "@modelStores/helpers/getters-helper";

export const useNewsArticleStore = defineStore("news-article-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
